import { CONSULTANT_ROLES } from '@/common/constants/consultantRoles';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useLayoutEffect, useState } from 'react';

const usePaymentData = () => {
	const [consultants, setConsultants] = useState();

	const {
		commonData: { users },
		filterUsersByRoles,
	} = useCommonDataContext();

	const handleGetConsultants = async () => {
		setConsultants(() => filterUsersByRoles(CONSULTANT_ROLES));
	};

	useLayoutEffect(() => {
		if (users[0]) {
			handleGetConsultants();
		}
	}, [users]);

	return { consultants };
};

export default usePaymentData;
